export const startsWithErrorMessage = 'The URL must start with "https://"';
export const maxUrlsErrorMessage = 'Pleaase provide a maximum of 5 entries';
export const atLeastOneInvalidUrl =
    'It looks like one of your entries is not a valid URL.';
